import { Pages } from "./pages"

export const App = () => {
    return (
        <Pages />
    )
}